export const CK_HASH = "dfdc9f0c68799bcba6c50e4c699e9e9a";
export const BACK_URL = "https://geely-himki.ru";
export const RESERVE_COOKIES = 'current:::typ=typein|||src=(direct)|||mdm=(direct)|||cmp=|||cnt=|||trm=^#^#session:::cpg=http://avtomir.dealer-mitsubishi.ru/^#^#';

export const WIDGET_KEY = 'geely-himki'; // check with the manager
export const MOD_ID = 'qnbgmj5c'; // check with the manager or in script of calltouch
export const SITE_ID = 36141; // check with the manager